import React from 'react'

import Tournament from '../../Icons/components/Award2'
import withCondition from '../../withCondition'
import GameIcon from './GameIcon'

function TournamentsIcon() {
  return (
    <GameIcon
      Icon={Tournament}
      className="game-in-tournament-icon"
      corner="right-top"
    />
  )
}

export default withCondition(TournamentsIcon)
